module.exports = __webpack_public_path__ + "img/threeDimensional.cf10fc46.png";